import { ImpersonationState } from "../model/ImpersonationState";

export interface IImpersonationService {
  persistedState?: ImpersonationState;
  saveImpersonationState(newState: ImpersonationState): void;
  clearImpersonationState(): void;
}

export const ImpersonationService = Symbol.for("ImpersonationService");
